.mainContainer {
  padding: 30px;
  flex-grow: 1;
}
